import { useEffect, useRef, useState } from 'react';
import {
  getEngagementDataAPI,
  getSkillPointsGraphAPI,
  getUserCredentialsAPI,
  getUserMetadataAPI,
  getUserMonthlyActivityAPI,
  getUserPathwaysAPI,
  getUserSkillsAPI,
} from './utils';
import { getUserName } from './helpers';

function useIndex() {
  const [userCredentialsDataLoaded, setUserCredentialsDataLoaded] =
    useState(false);
  const [userCredentialsData, setUserCredentialsData] = useState({});
  const hasFetchedData = useRef(false);
  const [userMonthlyActivityData, setUserMonthlyActivityData] = useState({});
  const [userMonthlyActivityDataLoaded, setUserMonthlyActivityDataLoaded] =
    useState(false);
  const [userMetadataData, setUserMetadataData] = useState({});
  const [userMetadataDataLoaded, setUserMetadataDataLoaded] = useState(false);
  const [userPathwaysData, setUserPathwaysData] = useState([]);
  const [userPathwaysDataLoaded, setUserPathwaysDataLoaded] = useState(false);
  const [userSkillsData, setUserSkillsData] = useState([]);
  const [userSkillsDataLoaded, setUserSkillsDataLoaded] = useState(false);
  const [engagementData, setEngagementData] = useState([]);
  const [engagementDataLoaded, setEngagementDataLoaded] = useState(false);
  const [skillPointsGraphData, setSkillPointsGraphData] = useState([]);
  const [skillPointsGraphDataLoaded, setSkillPointsGraphDataLoaded] =
    useState(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserCredentialsAPI(getUserName(), userCredentialsCallback);
      getUserMonthlyActivityAPI(userMonthlyActivityCallback);
      getUserMetadataAPI(getUserName(), userMetadataCallback);
      getUserPathwaysAPI(getUserName(), userPathwaysCallback);
      getUserSkillsAPI(getUserSkillsCallback);
      getEngagementDataAPI(engagementDataCallback);
      getSkillPointsGraphAPI(skillPointsGraphCallback);

      hasFetchedData.current = true;
    }
  }, []);

  const skillPointsGraphCallback = (data) => {
    setSkillPointsGraphData(data);
    setSkillPointsGraphDataLoaded(true);
  };

  const engagementDataCallback = (data) => {
    setEngagementData(data);
    setEngagementDataLoaded(true);
  };

  const getUserSkillsCallback = (data) => {
    setUserSkillsDataLoaded(true);
    setUserSkillsData(data);
  };

  const userCredentialsCallback = (data) => {
    setUserCredentialsData(data);
    setUserCredentialsDataLoaded(true);
  };

  const userMonthlyActivityCallback = (data) => {
    setUserMonthlyActivityData(data);
    setUserMonthlyActivityDataLoaded(true);
  };

  const userMetadataCallback = (data) => {
    setUserMetadataData(data);
    setUserMetadataDataLoaded(true);
  };

  const userPathwaysCallback = (data) => {
    setUserPathwaysData(data);
    setUserPathwaysDataLoaded(true);
  };

  return [
    userCredentialsData,
    userCredentialsDataLoaded,
    userMonthlyActivityData,
    userMonthlyActivityDataLoaded,
    /*userMetadataData,
    userMetadataDataLoaded,*/
    userPathwaysData,
    userPathwaysDataLoaded,
    userSkillsData,
    userSkillsDataLoaded,
    engagementData,
    engagementDataLoaded,
    skillPointsGraphData,
    skillPointsGraphDataLoaded,
  ];
}

export { useIndex };
